/* Order tracker page (sections/main-track.liquid). Lookup form -> result card.
   live: POST { order, email } or { tracking } to the tracker worker (data-worker); the worker verifies the order with
         Shopify, reads 17TRACK, runs track-core.js and returns { ok, order, result }.
   mock: read assets/track-mock.json + track-rewrites.json and run track-core.js here, same render path.
   The page never invents an event: everything drawn comes from the result object. Times are shown in the visitor's
   local time zone. A timeline row shows a location only when it is in the United States (TrackCore.isUSLocation);
   any other location, and the carrier's own English wording, sit behind the row's "Show details" button. A row with
   neither gets no button. No CJK character is ever drawn: every string passes through esc(), which strips CJK
   (track-core.js stripCJK) as a last guard behind the worker and the core, which already return clean text. */
(function () {
  "use strict";
  var root = document.getElementById("track");
  var form = document.getElementById("track-form");
  if (!root || !form) return;
  var $ = function (s, el) { return (el || root).querySelector(s); };
  var out = $("#track-result"), err = $("#track-error"), submit = $("#track-submit");
  var cfg = root.dataset;
  var shipping = { processing_days: [+cfg.shipMin || 2, +cfg.shipMax || 4], delivery_days: [+cfg.deliverMin || 8, +cfg.deliverMax || 15] };
  var opts = { gapDays: +cfg.gapDays || 3, staleDays: +cfg.staleDays || 7 };
  var tab = "order";
  var noCJK = function (s) { var t = String(s == null ? "" : s); return window.TrackCore && window.TrackCore.stripCJK ? window.TrackCore.stripCJK(t) : t.replace(/[\u1100-\u11FF\u2E80-\u33FF\u3400-\u4DBF\u4E00-\u9FFF\uA000-\uA4CF\uA960-\uA97F\uAC00-\uD7FF\uF900-\uFAFF\uFE10-\uFE1F\uFE30-\uFE4F\uFF00-\uFFEF]|[\uD840-\uD8BF][\uDC00-\uDFFF]/g, ""); };
  var esc = function (s) { return noCJK(s).replace(/[&<>"']/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]; }); };
  var fmtDate = function (iso, withTime) {
    if (!iso) return "";
    var d = new Date(iso);
    if (isNaN(d)) return "";
    var o = { month: "short", day: "numeric" };
    if (withTime) { o.hour = "numeric"; o.minute = "2-digit"; }
    try { return new Intl.DateTimeFormat(undefined, o).format(d); } catch (e) { return d.toDateString(); }
  };
  var range = function (a, b) {
    var da = new Date(a), db = new Date(b);
    var sameMonth = da.getMonth() === db.getMonth() && da.getFullYear() === db.getFullYear();
    return fmtDate(a) + " to " + (sameMonth ? db.getDate() : fmtDate(b));
  };

  /* ---------- tabs ---------- */
  var tabs = root.querySelectorAll("[role=tab]");
  Array.prototype.forEach.call(tabs, function (t) {
    t.addEventListener("click", function () {
      tab = t.dataset.tab;
      Array.prototype.forEach.call(tabs, function (x) { var on = x === t; x.setAttribute("aria-selected", on ? "true" : "false"); x.tabIndex = on ? 0 : -1; });
      Array.prototype.forEach.call(root.querySelectorAll("[data-panel]"), function (p) { p.hidden = p.dataset.panel !== tab; });
      showError("");
      var first = $("[data-panel='" + tab + "'] input");
      if (first) first.focus({ preventScroll: true });
    });
  });

  function showError(msg) { err.textContent = msg || ""; err.hidden = !msg; }
  function busy(on) { submit.disabled = on; submit.classList.toggle("is-busy", on); $(".track-submit-label", submit).textContent = on ? "Looking up your order" : "Track my order"; }

  /* ---------- data sources ---------- */
  var cache = {};
  function getJSON(url) {
    if (!cache[url]) cache[url] = fetch(url, { credentials: "omit" }).then(function (r) { if (!r.ok) throw new Error("HTTP " + r.status); return r.json(); });
    return cache[url];
  }
  function lookupMock(q) {
    return Promise.all([getJSON(cfg.mock), getJSON(cfg.rules)]).then(function (res) {
      var mock = res[0], rules = res[1], core = window.TrackCore.compile(rules);
      var entry = null;
      if (q.order) {
        entry = mock.orders[q.order] || null;
      } else {
        Object.keys(mock.orders).forEach(function (k) {
          var o = mock.orders[k];
          if (!entry && (o.tracks || []).some(function (t) { return (t.number || "").toUpperCase() === q.tracking; })) entry = o;
        });
      }
      if (!entry) return { ok: false, code: "not_found" };
      var order = q.order ? entry.order : null;
      var tracks = q.order ? entry.tracks : entry.tracks.filter(function (t) { return true; });
      return { ok: true, order: order, result: window.TrackCore.buildResult(core, order || { fulfillments: [] }, tracks, shipping, Object.assign({ now: mock.now }, opts)) };
    });
  }
  function lookupLive(q) {
    var url = (cfg.worker || "").replace(/\/$/, "");
    if (!url) return Promise.resolve({ ok: false, code: "not_connected" });
    return fetch(url + "/lookup", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(q), credentials: "omit" })
      .then(function (r) { return r.json().catch(function () { return { ok: false, code: r.status === 429 ? "rate_limited" : "error" }; }); })
      .catch(function () { return { ok: false, code: "network" }; });
  }

  /* ---------- submit ---------- */
  form.addEventListener("submit", function (e) {
    e.preventDefault();
    var q = {};
    if (tab === "order") {
      var on = ($("#track-order").value || "").replace(/^\s*#/, "").trim();
      var em = ($("#track-email").value || "").trim().toLowerCase();
      if (!on || !em || !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(em)) return showError("Enter your order number and the email you used at checkout.");
      q = { order: on, email: em };
    } else {
      var tn = ($("#track-number").value || "").replace(/\s+/g, "").toUpperCase();
      if (tn.length < 6) return showError("Paste the tracking number from your shipping email.");
      q = { tracking: tn };
    }
    showError(""); busy(true);
    (cfg.mode === "mock" ? lookupMock(q) : lookupLive(q)).then(function (res) {
      busy(false);
      if (!res || !res.ok) return renderFailure(res && res.code, q);
      render(res, q);
    }, function () { busy(false); renderFailure("error", q); });
  });

  /* ---------- render ---------- */
  var ICON = {
    confirmed: '<svg viewBox="0 0 24 24"><path d="M5 12.5l4.5 4.5L19 7"/></svg>',
    processing: '<svg viewBox="0 0 24 24"><path d="M3.5 7.5L12 3l8.5 4.5v9L12 21l-8.5-4.5z"/><path d="M3.5 7.5L12 12l8.5-4.5M12 12v9"/></svg>',
    shipped: '<svg viewBox="0 0 24 24"><path d="M3 7h11v9H3zM14 10h4l3 3v3h-7z"/><circle cx="7" cy="18" r="1.6"/><circle cx="17" cy="18" r="1.6"/></svg>',
    in_transit: '<svg viewBox="0 0 24 24"><path d="M3 14l8-2 3-7 2 .6-1.5 6.1 6.5-1.6.5 2-7 2.5-3.5 5.4-2-.4 2-5.2-6.5 1.6z"/></svg>',
    out_for_delivery: '<svg viewBox="0 0 24 24"><path d="M4 11l8-6 8 6v9H4z"/><path d="M10 20v-5h4v5"/></svg>',
    delivered: '<svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="9"/><path d="M8 12.5l2.5 2.5L16 9.5"/></svg>',
    info: '<svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="9"/><path d="M12 8v.5M12 11v5"/></svg>',
    alert: '<svg viewBox="0 0 24 24"><path d="M12 3l9.5 17h-19z"/><path d="M12 10v4M12 17v.5"/></svg>',
    ext: '<svg viewBox="0 0 24 24"><path d="M14 4h6v6M20 4l-9 9M19 14v5a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h5"/></svg>'
  };
  var TOGGLE_SHOW = "Show details", TOGGLE_HIDE = "Hide details";
  /* Display rule for locations: US locations show on the row and in the summary; any other location (and anything
     unrecognised) shows only inside "Show details". Without track-core.js loaded, no location counts as US. */
  var isUS = function (loc) { return !!(window.TrackCore && window.TrackCore.isUSLocation && window.TrackCore.isUSLocation(noCJK(loc))); };
  var CONTACT_KINDS = { delayed: 1, exception: 1, late: 1, no_scan_long: 1, cancelled: 1 };

  function renderFailure(code, q) {
    var h, p;
    if (code === "not_found") {
      h = q.order ? "We could not find that order" : "We could not find that tracking number";
      p = q.order ? "Check the order number (it is in your confirmation email, after the #) and that the email matches the one you used at checkout. Still stuck? Contact us and we will look it up."
                  : "Check the number from your shipping email. If it is less than a day old, the carrier may not have registered it yet.";
    } else if (code === "rate_limited") { h = "Too many lookups"; p = "Give it a few minutes and try again."; }
    else if (code === "not_connected") { h = "Tracking lookup is not connected yet"; p = "Email us your order number and we will send your tracking link."; }
    else { h = "Something went wrong on our side"; p = "Try again in a moment. If it keeps happening, contact us with your order number."; }
    out.innerHTML = '<article class="card track-card track-fail"><span class="track-ic" aria-hidden="true">' + ICON.info + '</span><h2>' + esc(h) + '</h2><p>' + esc(p) + '</p>' +
      '<p class="track-actions"><a class="btn ghost" href="' + esc(cfg.contact) + '">Contact us</a></p></article>';
    out.hidden = false;
    out.scrollIntoView({ block: "start", behavior: "smooth" });
  }

  function render(res, q) {
    var r = res.result, o = res.order;
    var parts = [];
    var meta = o && o.number ? "Order #" + esc(o.number) + (o.placed ? " placed " + esc(fmtDate(o.placed)) : "") : "Tracking " + esc(q.tracking || "");
    var chips = [];
    if (r.deliveredAt) chips.push('<span class="chip ok">Delivered ' + esc(fmtDate(r.deliveredAt)) + "</span>");
    else if (r.status === "cancelled") chips.push('<span class="chip soft">Cancelled</span>');
    else if (r.late || r.status === "delayed") chips.push('<span class="chip urgent">Running late</span>' + (r.eta ? '<span class="track-eta-note">Our estimate was ' + esc(range(r.eta.from, r.eta.to)) + "</span>" : ""));
    else if (r.eta) chips.push('<span class="chip soft">Estimated delivery ' + esc(range(r.eta.from, r.eta.to)) + "</span>" + (r.shipEstimated ? '<span class="track-eta-note">Window from our ' + shipping.processing_days[0] + " to " + shipping.processing_days[1] + " business day processing plus " + shipping.delivery_days[0] + " to " + shipping.delivery_days[1] + " day delivery.</span>" : '<span class="track-eta-note">An estimate from the ship date, not a promise.</span>'));
    parts.push('<header class="track-status status-' + esc(r.status) + '"><p class="label">' + meta + (o && o.firstName ? '<span class="sep" aria-hidden="true"></span>' + esc(o.firstName) : "") + "</p>" +
      "<h2>" + esc(r.headline) + "</h2>" +
      (r.latest ? '<p class="track-latest"><b>Latest carrier update</b> ' + esc(fmtDate(r.latest.time, true)) + (r.latest.location && isUS(r.latest.location) ? ' <span class="muted">' + esc(r.latest.location) + "</span>" : "") + "</p>"
                : '<p class="track-latest"><b>Latest carrier update</b> none yet</p>') +
      (chips.length ? '<div class="track-chips">' + chips.join("") + "</div>" : "") + "</header>");

    parts.push('<ol class="track-steps" aria-label="Progress">' + r.steps.map(function (s) {
      var cls = s.done ? "done" : s.current ? "current" : "";
      if (s.current && (r.status === "exception" || r.status === "delayed" || r.late)) cls += " warn";
      return '<li class="' + cls + '"><span class="track-dot" aria-hidden="true">' + (ICON[s.key] || "") + '</span><span class="track-step-label">' + esc(s.label) + "</span>" +
        (s.date && (s.done || s.current) ? '<time datetime="' + esc(s.date) + '">' + esc(fmtDate(s.date)) + "</time>" : "") +
        (s.current ? '<span class="sr-only"> (current)</span>' : "") + "</li>";
    }).join("") + "</ol>");

    if (r.notice) {
      var text = r.notice.text.replace("[date]", fmtDate(r.notice.since));
      var warn = CONTACT_KINDS[r.notice.kind];
      parts.push('<div class="track-notice kind-' + esc(r.notice.kind) + '"><span class="track-ic" aria-hidden="true">' + (warn ? ICON.alert : ICON.info) + "</span><p>" + esc(text) + "</p>" +
        (warn ? '<a class="btn ghost" href="' + esc(cfg.contact) + '">Contact us</a>' : "") + "</div>");
    }

    if (r.carriers && r.carriers.length) {
      parts.push('<ul class="track-carriers">' + r.carriers.map(function (c) {
        return "<li><span><b>" + esc(c.name) + "</b> " + esc(c.number) + "</span>" + (c.url ? '<a href="' + esc(c.url) + '" target="_blank" rel="noopener">Carrier site' + ICON.ext + "</a>" : "") + "</li>";
      }).join("") + "</ul>");
    }

    if (r.events && r.events.length) {
      parts.push('<details class="track-timeline" open><summary>Full timeline <span class="muted">' + r.events.length + (r.events.length === 1 ? " update" : " updates") + "</span></summary><ol>" + r.events.map(function (e, i) {
        var id = "ev-raw-" + i;
        var wording = noCJK(e.carrierText).trim();
        var same = wording.replace(/\.$/, "").toLowerCase() === noCJK(e.message).replace(/\.$/, "").toLowerCase();
        var carrier = noCJK(e.carrier).trim();
        var place = noCJK(e.location).trim(), rawPlace = noCJK(e.carrierLocation).trim() || place;
        var rowLoc = place && isUS(place) ? place : "";
        var detailLoc = rawPlace && rawPlace !== rowLoc ? rawPlace : "";
        var showWording = !!(wording && !same);
        return '<li class="ev kind-' + esc(e.kind) + '"><time datetime="' + esc(e.time) + '">' + esc(fmtDate(e.time, true)) + "</time>" +
          '<div class="ev-body"><p>' + esc(e.message) + "</p>" + (rowLoc ? '<span class="ev-loc">' + esc(rowLoc) + "</span>" : "") +
          (showWording || detailLoc ? '<button type="button" class="ev-toggle" aria-expanded="false" aria-controls="' + id + '">' + TOGGLE_SHOW + "</button>" +
            '<div class="ev-raw" id="' + id + '" hidden>' + (showWording ? '<span class="ev-raw-text">' + esc(wording) + "</span>" : "") +
            (detailLoc ? '<span class="ev-raw-loc">' + esc(detailLoc) + "</span>" : "") + (carrier ? '<span class="ev-raw-carrier">' + esc(carrier) + "</span>" : "") + "</div>" : "") +
          "</div></li>";
      }).join("") + "</ol></details>");
    }

    parts.push('<p class="track-foot">Carrier events are shown in plain English. Tap Show details on an update for the carrier\'s own English wording and the scan location. Nothing here is estimated except the delivery window.</p>');
    out.innerHTML = '<article class="card track-card">' + parts.join("") + "</article>";
    out.hidden = false;
    out.scrollIntoView({ block: "start", behavior: "smooth" });
  }

  out.addEventListener("click", function (e) {
    var b = e.target.closest(".ev-toggle");
    if (!b) return;
    var box = document.getElementById(b.getAttribute("aria-controls"));
    var open = b.getAttribute("aria-expanded") === "true";
    b.setAttribute("aria-expanded", open ? "false" : "true");
    b.textContent = open ? TOGGLE_SHOW : TOGGLE_HIDE;
    box.hidden = open;
  });

  /* Deep link: /pages/track?order=1001&email=... fills the form; a mock preview link can also pass ?lookup=1 to run it. */
  try {
    var sp = new URLSearchParams(location.search);
    if (sp.get("order")) $("#track-order").value = sp.get("order");
    if (sp.get("email")) $("#track-email").value = sp.get("email");
    if (sp.get("tracking") && $("#track-tab-tracking")) { $("#track-number").value = sp.get("tracking"); $("#track-tab-tracking").click(); }
    if (sp.get("lookup") === "1") form.requestSubmit ? form.requestSubmit() : form.dispatchEvent(new Event("submit", { cancelable: true }));
  } catch (e) { /* no URL API */ }
})();
